/*
 *   Copyright (c) 2025 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 */
import { Divider, Row, Space } from "antd"
import { Link, graphql, useStaticQuery } from "gatsby"
import { StaticImage, GatsbyImage } from "gatsby-plugin-image"
import * as React from "react"
import theme from "../styles/theme"

const Footer: React.FC = () => {
  const data = useStaticQuery(graphql`
    query {
      strapiSiteSetting {
        footerContent {
          fundingTextEU
          fundingTextSwiss
          aboutLink
          contactLink
        }
        copyrightText
      }
    }
  `)

  const footerContent = data.strapiSiteSetting?.footerContent
  const copyrightText =
    data.strapiSiteSetting?.copyrightText ||
    "Luxembourg Institute of Science and Technology. All rights reserved."
  const euFundingImage = null // Use static image until Strapi is populated
  const euFundingAlt = "EU funding"

  const fundingTextEU =
    footerContent?.fundingTextEU ||
    "This project has received funding from the European Union's Horizon research and innovation programme under grant agreement No 101147328."
  const fundingTextSwiss =
    footerContent?.fundingTextSwiss ||
    "This work has received funding from the Swiss State Secretariat for Education, Research and Innovation (SERI) for the Swiss partners."
  const aboutLink =
    footerContent?.aboutLink || "https://reskilling-project.eu/index.php/about"
  const contactLink =
    footerContent?.contactLink ||
    "https://reskilling-project.eu/index.php/contacts/"

  return (
    <div
      style={{
        backgroundColor: theme.primaryColor,
        color: theme.colorBgBase,
      }}
    >
      <Row justify="center" align="middle">
        {euFundingImage ? (
          <GatsbyImage
            image={euFundingImage}
            alt={euFundingAlt}
            style={{ margin: "1rem" }}
          />
        ) : (
          <StaticImage
            src="../images/EUfunding.png"
            alt="EUfundings"
            style={{ margin: "1rem" }}
            width={79}
            height={53}
          />
        )}
        <Space
          direction="vertical"
          size="small"
          style={{ textAlign: "center" }}
        >
          <span>{fundingTextEU}</span>
          <span>{fundingTextSwiss}</span>
        </Space>
      </Row>
      <Row
        justify={"center"}
        align="middle"
        style={{ paddingBottom: "0.5rem" }}
      >
        <div>
          <Link to={aboutLink} target="_blank" rel="noopener noreferrer">
            About
          </Link>
          <Divider type="vertical" />
          <Link to={contactLink} target="_blank" rel="noopener noreferrer">
            Contact
          </Link>
        </div>
      </Row>
      <Row
        justify={"center"}
        align="bottom"
        style={{ paddingBottom: "0.5rem" }}
      >
        <small>{copyrightText}</small>
      </Row>
    </div>
  )
}

export default Footer
